import { render, staticRenderFns } from "./workCenter-add-or-update.vue?vue&type=template&id=4daa31af&scoped=true"
import script from "./workCenter-add-or-update.vue?vue&type=script&lang=js"
export * from "./workCenter-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./workCenter-add-or-update.vue?vue&type=style&index=0&id=4daa31af&prod&scoped=true&lang=css"
import style1 from "./workCenter-add-or-update.vue?vue&type=style&index=1&id=4daa31af&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daa31af",
  null
  
)

export default component.exports